import { gql } from '@apollo/client';

const bodyStyle = {
  BODY_STYLE: gql`
    fragment BodyStyle on BodyStyle {
      code
      attributes {
        shortname
        longdescription
        bodyStyleType @include(if: $dataLayer)
        oemcode @include(if: $dataLayer)
      }
    }
  `,
};

export default bodyStyle;
